import { Component } from 'react';

import Title from '../atoms/Title';
import BodyText from '../atoms/BodyText';

import * as Breakpoints from '../../../constants/breakpoints';
import * as InternalPropTypes from '../../../constants/internal-types';
import TitleTypes from '../../../constants/title-types';
import { TypeSEOWeightTypes } from '../../../constants/cms-constants';
import SEOWeights from '../../../constants/cms/control-options/seo-weights';
import { getSEOWeight } from '../../../utils/SEOWeight';

const styles = {
  '& .body-text': {
    [Breakpoints.Mobile.mq]: {
      paddingTop: '24px',
    },
    [Breakpoints.Tablet.mq]: {
      width: '90%',
    },
    [Breakpoints.TabletUp.mq]: {
      paddingTop: '80px',
    },
    [Breakpoints.DesktopUp.mq]: {
      width: '80%',
    },
  },
};

type CasesHeroProps = {
  header?: InternalPropTypes.RichText;
  lightHeader?: InternalPropTypes.RichText;
  seoWeight?: TypeSEOWeightTypes;
};

class CasesHero extends Component<CasesHeroProps> {
  static defaultProps = {
    header: null,
    lightHeader: null,
    seoWeight: SEOWeights.H1,
  };

  render() {
    const { header, lightHeader, seoWeight } = this.props;

    const addSEOWeight = getSEOWeight(seoWeight, seoWeight);
    return (
      <div css={styles}>
        <Title seoWeight={addSEOWeight} type={TitleTypes.CASES}>
          {header}
        </Title>
        <BodyText as="p" type={BodyText.types.QUOTEBLOCK}>
          {lightHeader}
        </BodyText>
      </div>
    );
  }
}

export default CasesHero;
